<template>
  <div
    v-for="user in users"
    :key="user.id"
    class="mt-3 mb-3 col-lg-4 col-md-6"
  >
    <user-card
      :board-member-function="user.boardMemberFunction"
      :clubs="user.clubs"
      :company-name="user.companyName"
      :id="user.id"
      :image="user.profilePicture"
      :is-activated="user.isActivated"
      :is-admin="user.isAdmin"
      :is-valid="user.isValid"
      :name="user.fullName"
      :profession="user.profession"
      @remove="removeItem(user.id)"
    />
  </div>
</template>

<script>
import UserCard from '../UserCard.vue';

export default {
  components: {
    UserCard
  },
  
  props: {
    users: {
      type: Array,
      default: () => [],
    }
  }
}
</script>